import { ServiceRequestDetail } from '@/components/services/ServiceRequestDetail'

export default function ServiceRequestDetailScreen() {
  return <ServiceRequestDetail />
}
